// Dependencies
import styled from 'styled-components';

const LatestBlogPostsStyles = styled.section`
  text-align: center;

  .heading {
    font-weight: var(--font-weight-regular);
  }

  .posts {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  @media (min-width: 992px) {
    .posts {
      display: grid;
      margin: 6.25rem 0 0 0;
      column-gap: 4rem;
      grid-auto-rows: 1fr;
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (min-width: 1500px) {
    .posts {
      column-gap: 8.75rem;
    }
  }
`;

export default LatestBlogPostsStyles;
